"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChallengeEmptyCard = ChallengeEmptyCard;
var _Card2 = _interopRequireDefault(require("@mui/material/Card"));
var _CardContent2 = _interopRequireDefault(require("@mui/material/CardContent"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _challengeEmptyState = _interopRequireDefault(require("../assets/images/challenge-empty-state.svg"));
var _trophy = _interopRequireDefault(require("../assets/images/trophy.svg"));
var _components = require("../components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ChallengeEmptyCard({
  Link,
  backgroundColor,
  userType
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/_react.default.createElement(_Card2.default, {
    elevation: 0,
    sx: {
      alignSelf: 'stretch',
      backgroundColor: backgroundColor || '#f6f7fb',
      borderRadius: 4
    },
    variant: "elevation"
  }, /*#__PURE__*/_react.default.createElement(_CardContent2.default, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      padding: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, userType === 'admin' ? /*#__PURE__*/_react.default.createElement("img", {
    src: _trophy.default,
    width: "60px"
  }) : /*#__PURE__*/_react.default.createElement("img", {
    src: _challengeEmptyState.default,
    style: {
      alignSelf: 'center'
    },
    width: "280px"
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 600
  }, t('commons.challenges.empty_state_title', {
    context: userType
  })), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, t('commons.challenges.empty_state_description', {
    context: userType
  })), userType === 'admin' && /*#__PURE__*/_react.default.createElement(_components.Button, {
    disableElevation: true,
    color: "primary",
    component: Link,
    size: "large",
    sx: {
      textTransform: 'initial',
      borderRadius: '8px !important'
    },
    to: "/new-challenge",
    variant: "contained"
  }, t('commons.challenges.actions.create')))));
}